import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M15 2C16.5977 2 17.9037 3.24892 17.9949 4.82373L18 5V8C18 8.26039 17.8985 8.50867 17.7202 8.6938L17.6247 8.78087L13.6 12L17.6247 15.2191C17.8619 15.4089 18 15.6962 18 16V19C18 20.6569 16.6569 22 15 22H9C7.34315 22 6 20.6569 6 19V16C6 15.6962 6.13809 15.4089 6.3753 15.2191L10.399 12L6.3753 8.78087C6.17198 8.61821 6.04148 8.38388 6.00834 8.12895L6 8V5C6 3.40232 7.24892 2.09634 8.82373 2.00509L9 2H15Z" />,
  'HourglassFull'
);
